import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { List } from 'immutable'
import dompurify from 'dompurify'

import Header from '../WelcomeMessageHeader'
import { ProfileIcon, DismissIcon } from '../icons'
import WelcomeMessageCard from '../WelcomeMessageCard'
import WelcomeMessagePreview from 'components/shared/PlaybookPreviews/WelcomeMessage/welcomeMessage'
import styles from './style.styl'

const MissingFonts = ['Lato', 'Open+Sans', 'Roboto+Slab', 'Overpass']

class WelcomeMessage extends Component {
  static propTypes = {
    title: PropTypes.node,
    message: PropTypes.node,
    children: PropTypes.node,
    users: PropTypes.object,
    backgroundColor: PropTypes.string,
    foregroundColor: PropTypes.string,
    showProfileIcon: PropTypes.bool,
    onProfileClick: PropTypes.func,
    showDismissIcon: PropTypes.bool,
    onDismissClick: PropTypes.func,
    isHTMLPreview: PropTypes.bool,
  }

  static defaultProps = {
    users: List(),
    isHTMLPreview: false,
  }

  componentDidMount() {
    this.loadMissingFonts()
  }

  loadMissingFonts = () => {
    MissingFonts.forEach((font) => {
      const $linkTag = document.createElement('link')
      $linkTag.rel = 'stylesheet'
      $linkTag.href = `https://fonts.googleapis.com/css?family=${font}|${font}:bold&display=swap`
      document.body && document.body.appendChild($linkTag)
    })
  }

  renderMenu() {
    const { showProfileIcon, showDismissIcon, onProfileClick, onDismissClick } = this.props
    return [
      showProfileIcon && (<ProfileIcon key="profile" onClick={onProfileClick}/>),
      showDismissIcon && (<DismissIcon key="dismiss" onClick={onDismissClick}/>),
    ].filter(Boolean)
  }

  render() {
    const {
      title,
      users,
      message,
      backgroundColor,
      foregroundColor,
      children,
      isHTMLPreview,
      callToAction
    } = this.props
    return (
      <WelcomeMessagePreview
        users={users}
        backgroundColor={backgroundColor}
        message={message}
        isHTMLPreview={isHTMLPreview}
        callToAction={callToAction}
      />
    )
  }
}

export default WelcomeMessage



// WEBPACK FOOTER //
// ./src/scripts/components/shared/MessagePreviews/WelcomeMessage/WelcomeMessageBuilder/index.js